import React, { useState } from 'react';
import { BarChart, Bar, YAxis, Tooltip, ResponsiveContainer } from 'recharts';
import { Button, Dialog, DialogContent, DialogTitle, Grid } from '@mui/material';
import { FormEditarTiempoTarea } from '../../../global/proyectos/tareas/FormEditarTiempoTarea';

export const BarrasHorasInvertidasTarea = ({ data, id_tarea, cargarTareas, setPausarRecargaTareas }) => {
    const [open, setOpen] = useState(false);
    const [selectedData, setSelectedData] = useState(null);

    const convertirHoras = (decimales) => {
        const horas = Math.floor(decimales);
        const minutos = Math.round((decimales - horas) * 60);
        return `${horas} horas${minutos > 0 ? ` ${minutos} minutos` : ''}`;
    };
    const parsearFechaDesdeCodigo = (codigo) => {
        const match = codigo.match(/[A-Z](\d{1,2})\/(\d{1,2})/);
        if (!match) return null;
        const dia = parseInt(match[1], 10);
        const mes = parseInt(match[2], 10) - 1;
        const hoy = new Date();
        return new Date(hoy.getFullYear(), mes, dia);
    };
    const obtenerFechaCompleta = (diaTexto) => {
        const match = diaTexto.match(/[A-Z](\d{1,2})\/(\d{1,2})/);
        if (!match) return diaTexto;
        const dia = parseInt(match[1], 10);
        const mes = parseInt(match[2], 10) - 1;
        const hoy = new Date();
        const fecha = new Date(hoy.getFullYear(), mes, dia);

        const diasLargos = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];
        const mesesLargos = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];

        return `${diasLargos[fecha.getDay()]} ${fecha.getDate()} de ${mesesLargos[fecha.getMonth()]}`;
    };


    const datos = data.map((item) => {
        const tareas = item.tareas || [];

        const tareasAgrupadas = {};
        const tareasAgrupadasPorId = {};

        tareas.forEach(t => {
            // Para las barras
            if (!tareasAgrupadas[t.usuario]) tareasAgrupadas[t.usuario] = 0;
            tareasAgrupadas[t.usuario] += t.horas;

            // Para el detalle por ID
            if (!tareasAgrupadasPorId[t.usuario]) tareasAgrupadasPorId[t.usuario] = {};
            const tareaId = t.id ?? 'sin-id';
            if (!tareasAgrupadasPorId[t.usuario][tareaId]) tareasAgrupadasPorId[t.usuario][tareaId] = 0;
            tareasAgrupadasPorId[t.usuario][tareaId] += t.horas;
        });

        const totalHoras = Object.values(tareasAgrupadas).reduce((sum, h) => sum + h, 0);

        return {
            dia: item.dia,
            fechaCompleta: obtenerFechaCompleta(item.dia),
            total: convertirHoras(totalHoras),
            tareasAgrupadasPorId,
            tareas: item.tareas, // conservar originales para editar
            ...tareasAgrupadas
        };
    });

    const tareasNombres = Array.from(
        new Set(data.flatMap(d => d.tareas?.map(t => t.usuario) || []))
    );

    const handleClick = (e) => {
        if (e && e.activePayload && e.activePayload.length) {
            const payload = e.activePayload[0].payload;
            setSelectedData(payload);
            setOpen(true);
        }
    };


    const CustomTooltip = ({ active, payload, backgroundCard, textColor }) => {
        if (active && payload && payload.length) {
            const item = payload[0].payload;
            const agrupadas = item.tareasAgrupadasPorId || {};

            return (
                <div
                    style={{
                        backgroundColor: "#1b1b1b",
                        color: 'white',
                        padding: '8px',
                        borderRadius: '10px',
                        fontSize: '12px',
                        position: 'absolute',
                        minWidth: '220px',
                        zIndex: 999999,
                        boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                        pointerEvents: 'none',
                        overflow: 'visible',
                        marginTop: '7.5em',
                    }}
                >
                    <strong>{item.fechaCompleta}</strong><br />
                    <div style={{ marginTop: '6px' }}>
                        <strong>Detalle por tarea:</strong>
                        <ul style={{ paddingLeft: '16px', margin: 0 }}>
                            {Object.entries(agrupadas).map(([usuario, tareas]) => (
                                <li key={usuario}>
                                    <strong>{usuario}</strong>
                                    <ul style={{ paddingLeft: '12px' }}>
                                        {Object.entries(tareas).map(([id, horas]) => {
                                            const h = Math.floor(horas);
                                            const m = Math.round((horas - h) * 60);
                                            return (
                                                <li key={id}>
                                                    {h}h{m > 0 ? ` ${m}min` : ''}
                                                </li>
                                            );
                                        })}
                                    </ul>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            );
        }
        return null;
    };

    return (
        <>
            <Grid container direction="row" justifyContent="start" alignItems="center" xs={12} gap={1}>
                <Grid container direction="row" justifyContent="start" alignItems="center" xs={12} md={3}  lg={2} gap={1}>

                    <Button
                        variant="contained"
                        color="primary"
                        size='small'
                        onClick={() => {
                            setSelectedData(null); // Sin selección específica
                            setOpen(true);
                        }}
                        sx={{ padding: 1, marginTop: 1, width: '100%' }}
                    >
                        Horas Invertidas
                    </Button>
                </Grid>

            </Grid>
            <div style={{ width: datos.length * 16, height: 90, overflow: 'visible' }}>
                <ResponsiveContainer width="100%" height="100%">
                    <BarChart data={datos} barCategoryGap={8} onClick={handleClick}>
                        <YAxis hide />
                        <Tooltip content={<CustomTooltip />} />
                        {tareasNombres.map((usuario, index) => (
                            <Bar
                                key={usuario}
                                dataKey={usuario}
                                stackId="2"
                                fill={`hsl(${(index * 60) % 360}, 70%, 60%)`}
                                barSize={60}
                            />
                        ))}
                    </BarChart>
                </ResponsiveContainer>
            </div>
            <Dialog open={open} onClose={() => setOpen(false)}>
                <DialogContent>
                    <DialogTitle>Editar tiempo</DialogTitle>
                    <FormEditarTiempoTarea
                        data={data}
                        open={open}
                        setOpen={setOpen}
                        initialDate={
                            selectedData?.dia
                                ? parsearFechaDesdeCodigo(selectedData.dia)
                                : new Date() // fecha actual si no hay selección
                        }
                        id_tarea={id_tarea}
                        cargarTareas={cargarTareas}
                        setPausarRecargaTareas={setPausarRecargaTareas}
                    />

                </DialogContent>
            </Dialog>
        </>
    );
};
